import React from 'react';
import cn from 'classnames';
import * as mobxReact from 'mobx-react';
import { injectIntl, IntlShape } from 'react-intl';
import { CommonPopupBodyFooterLayout } from '../../../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../../../global/sub-window/common/common-close-sub-window-buttons';
import { EmailsTemplateFormVM } from '../emails-template-form.viewmodel';
import { PassportField } from '../../passport-field/passport-field';
import DefaultButton from '../../../../../../global/default-button/default-button';
import { DONE_TEXT } from '../../../../../../../constants/common-labels.constants';
import {
    REGISTRATION_CALENDAR_INVITATION_DISABLED_TEXT,
    REGISTRATION_CALENDAR_INVITATION_TITLE,
    RESPONSIVE_EMAILS_DISABLED
} from '../emails-template-form.texts';

interface IProps {
    vm: EmailsTemplateFormVM;
    intl: IntlShape;
}

export const EmailTemplatesFormPresentation = injectIntl(mobxReact.observer((props: IProps) => {
    const { vm, intl } = props;
    if (vm.loading) {
        return <CommonPopupBodyFooterLayout
            body={
                <div className='oe-form'>
                    {intl.formatMessage({
                        id: 'oe.website.registrationEmailDataLoading',
                        description: 'Placeholder about loading registration email data',
                        defaultMessage: 'Loading Registration Email data...'
                    })}
                </div>
            } />;
    }

    return (
        <CommonPopupBodyFooterLayout
            className='oe-form'
            body={
                <div className='email-templates-form oe-form-body'>
                    {vm.emailTemplatesNames.map(templateTitle => {
                        const isDisabled = templateTitle === REGISTRATION_CALENDAR_INVITATION_TITLE
                            ? !vm.emailTemplates.find(el => el.name === templateTitle)?.autoSubscribed
                            : !vm.emailTemplates.find(el => el.name === templateTitle)?.enabled;

                        return (
                            <div
                                key={templateTitle}
                                className={cn(
                                    'email-templates-item',
                                    {
                                        'email-templates-item--selected': templateTitle === vm.currentTemplate,
                                        'email-templates-item--disabled': isDisabled,
                                    }
                                )}
                            >
                                <PassportField
                                    className='email-templates-form--title'
                                    onClick={() => vm.showScheduledEmailForm(templateTitle)}
                                    buttonText={intl.formatMessage({
                                        id: 'oe.common.configure',
                                        defaultMessage: 'Configure',
                                        description: 'Button text',
                                    })}
                                    rowText={intl.formatMessage({
                                        id: `oe.passport.responsiveEmails.${templateTitle.split(' ').join('')}`,
                                        defaultMessage: templateTitle,
                                        description: 'Button text',
                                    })}
                                    additionalRowText={
                                        isDisabled
                                            ? intl.formatMessage(
                                                  templateTitle === REGISTRATION_CALENDAR_INVITATION_TITLE
                                                      ? REGISTRATION_CALENDAR_INVITATION_DISABLED_TEXT
                                                      : RESPONSIVE_EMAILS_DISABLED
                                              )
                                            : ''
                                    }
                                />
                            </div>
                        );
                    })}
                    {vm.triagedRegistrationEnabled &&
                        <DefaultButton
                            className='m-top-30px'
                            modifier={['lite']}
                            text={intl.formatMessage({
                                id: 'oe.passport.responsiveEmails.addResponsiveEmail',
                                description: 'Button text',
                                defaultMessage: '+ Add Responsive Email',
                            })}
                            onClick={vm.showCreateEmailTemplateForm}
                            disabled={vm.isCreateEmailTemplatePopUpOpen}
                        />

                    }
                </div>
            }
            footer={
                <>
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultCloseSubWindowButton
                            text={intl.formatMessage(DONE_TEXT)}
                            modifier={['fat', 'confirm-safe']}
                        />
                    </div>
                </>
            }
        />
    );
}));
